import { useContext } from 'react';
import { VoluntaryApproversContext } from './context';
export const useVoluntaryApprovers = () => {
    const context = useContext(VoluntaryApproversContext);
    if (!context) {
        throw new Error('useVoluntaryApprovers hook must be used as a child to <VoluntaryApproversProvider>');
    }
    return context;
};
